import React from "react";
import BraidCard from "../components/BraidCard";
import { braids } from "../data/braids";

function Catalogue() {
  return (
    <main className="catalogue">
      <header className="catalogue-header">
        <h1>Braid Catalogue</h1>
        <p>Choose your favorite style to customize and book.</p>
      </header>

      <div className="braid-grid">
        {braids.map((braid) => (
          <BraidCard
            key={braid.id}
            braid={braid}
          />
        ))}
      </div>
    </main>
  );
}

export default Catalogue;